<template>
  <div class="grid grid-cols-7 gap-2">
    <activity-week-day day="Mo" :status="checkDays(0)" />
    <activity-week-day day="Di" :status="checkDays(1)" />
    <activity-week-day day="Mi" :status="checkDays(2)" />
    <activity-week-day day="Do" :status="checkDays(3)" />
    <activity-week-day day="Fr" :status="checkDays(4)" />
    <activity-week-day day="Sa" :status="checkDays(5)" />
    <activity-week-day day="So" :status="checkDays(6)" />
  </div>
</template>

<script>
import DateMixin from "@/mixins/DateMixin";

const ActivityWeekDay = require("@/modules/activities/components/ActivityWeekDay.vue")
  .default;

export default {
  name: "ActivityWeek",
  mixins: [DateMixin],
  data() {
    return {
      todayNumber: null
    };
  },
  props: {
    days: {
      type: Array
    }
  },
  components: {
    ActivityWeekDay
  },
  methods: {
    checkDays(DayNumber) {
      if (this.dayNumbers.includes(DayNumber)) {
        return "checked";
      } else if (DayNumber < this.todayNumber) {
        return "missed";
      } else {
        return "ongoing";
      }
    }
  },
  computed: {
    dayNumbers() {
      return this.days.map(e => this.getDayNumber(e));
    }
  },
  created() {
    this.todayNumber = this.getTodayNumber();
  }
};
</script>
